import {Menu} from "antd"
import {NavLink} from "react-router-dom"
import React, {memo} from "react"
import {FaLaptopHouse, FaLayerGroup, FaUser, FaUsers} from "react-icons/fa"
import {BsBell, BsBuilding, BsJournalText, BsShieldLock} from "react-icons/bs"
import {GiGearHammer, GiGearStickPattern} from "react-icons/gi"
import {RxGear} from "react-icons/rx"
import {TfiList} from "react-icons/tfi"
import {AiFillHome, AiOutlineBug} from "react-icons/ai"
import {LiaListAlt} from "react-icons/lia"
import {ID_SYSTEM_COMPANY} from "../constants/constants"
import {UserResponse} from "../models/response"
import {UserTypeEnum} from "../types/types"

type PropsTypes = {
    profile: UserResponse | null
}
export const Sidenav: React.FC<PropsTypes> = memo(({profile}) =>
{

    return (
        <>
            <div className="brand">
                <NavLink to="/dashboard" className="brand-title">
                    Lika
                </NavLink>
            </div>
            <hr/>
            <Menu theme="light" mode="inline">
                <Menu.Item key="1">
                    <NavLink to="/dashboard">
                        <span className="icon">
                            <AiFillHome size={20}/>
                        </span>
                        <span className="label">Главная</span>
                    </NavLink>
                </Menu.Item>

                {
                    profile?.idUserType === UserTypeEnum.ADMIN_SYSTEM || profile?.idUserType === UserTypeEnum.ADMIN_COMPANY
                        ? <>
                            <Menu.Item key="2">
                                <NavLink to="/userGroup" isActive={(match, location) =>
                                {
                                    if (location.pathname.match(/\/userGroupForm/)) return true
                                    return !!match
                                }}>
                                    <span className="icon">
                                        <FaUsers size={20}/>
                                    </span>
                                    <span className="label">Группы пользователей</span>
                                </NavLink>
                            </Menu.Item>

                            <Menu.Item key="3">
                                <NavLink to="/user" isActive={(match, location) =>
                                {
                                    if (location.pathname.match(/\/userForm/)) return true
                                    return !!match
                                }}>
                                    <span className="icon">
                                        <FaUser size={20}/>
                                    </span>
                                    <span className="label">Пользователи</span>
                                </NavLink>
                            </Menu.Item>
                        </>
                        : null
                }

                {
                    profile?.idCompany === ID_SYSTEM_COMPANY
                        ? <Menu.Item key="4">
                            <NavLink to="/company" isActive={(match, location) =>
                            {
                                if (location.pathname.match(/\/companyForm/)) return true
                                return !!match
                            }}>
                                <span className="icon">
                                    <BsBuilding size={20}/>
                                </span>
                                <span className="label">Компании</span>
                            </NavLink>
                        </Menu.Item>
                        : null
                }

                <Menu.Item key="5">
                    <NavLink to="/objectGroup" isActive={(match, location) =>
                    {
                        if (location.pathname.match(/\/objectGroupForm/)) return true
                        return !!match
                    }}>
                        <span className="icon">
                            <FaLayerGroup size={20}/>
                        </span>
                        <span className="label">Группы объектов</span>
                    </NavLink>
                </Menu.Item>

                <Menu.Item key="6">
                    <NavLink to="/object" isActive={(match, location) =>
                    {
                        if (location.pathname.match(/\/objectForm/)) return true
                        return !!match
                    }}>
                        <span className="icon">
                            <FaLaptopHouse size={20}/>
                        </span>
                        <span className="label">Объекты</span>
                    </NavLink>
                </Menu.Item>

                <Menu.Item key="7">
                    <NavLink to="/psLeakDevice" isActive={(match, location) =>
                    {
                        if (location.pathname.match(/\/psLeakDeviceForm/)) return true
                        if (location.pathname.match(/\/PSLeakDeviceUpdate/)) return true
                        return !!match
                    }}>
                        <span className="icon">
                            <GiGearStickPattern size={20}/>
                        </span>
                        <span className="label">Оборудование</span>
                    </NavLink>
                </Menu.Item>

                {
                    profile?.idUserType === UserTypeEnum.ADMIN_SYSTEM || profile?.idUserType === UserTypeEnum.ADMIN_COMPANY
                    ? <Menu.Item key="8">
                            <NavLink to="/psLeakUinList" isActive={(match, location) =>
                            {
                                if (location.pathname.match(/\/psLeakUinListForm/)) return true
                                return !!match
                            }}>
                        <span className="icon">
                            <LiaListAlt size={20}/>
                        </span>
                                <span className="label">Список UIN</span>
                            </NavLink>
                        </Menu.Item>
                        : null
                }

                {
                    profile?.idCompany === ID_SYSTEM_COMPANY ? <Menu.Item key="9">
                            <NavLink to="/unregisterPsLeakDevice">
                                <span className="icon">
                                    <TfiList size={20}/>
                                </span>
                                <div style={{display: "flex", flexDirection: "column"}}>
                                    <span className="label">Не зарегистрированное</span>
                                    <span className="label"> оборудование</span>
                                </div>
                            </NavLink>
                        </Menu.Item>
                        : null
                }

                <Menu.Item key="10">
                    <NavLink to="/psLeakDeviceLog" isActive={(match, location) =>
                    {
                        if (location.pathname.match(/\/psLeakDeviceLog/)) return true
                        return !!match
                    }}>
                        <span className="icon">
                            <BsJournalText size={20}/>
                        </span>
                        <span className="label">Системные логи</span>
                    </NavLink>
                </Menu.Item>

                <Menu.Item key="11">
                    <NavLink to="/psLeakDeviceLocalLog" isActive={(match, location) =>
                    {
                        if (location.pathname.match(/\/psLeakDeviceLocalLog/)) return true
                        return !!match
                    }}>
                        <span className="icon">
                            <AiOutlineBug size={20}/>
                        </span>
                        <span className="label">Логи устройств</span>
                    </NavLink>
                </Menu.Item>

                <Menu.Item key="12">
                    <NavLink to="/psLeakDeviceIndication" isActive={(match, location) =>
                    {
                        if (location.pathname.match(/\/psLeakDeviceIndication/)) return true
                        return !!match
                    }}>
                        <span className="icon">
                            <BsBell size={20}/>
                        </span>
                        <span className="label">Показания устройств</span>
                    </NavLink>
                </Menu.Item>

                <Menu.Item key="13">
                    <NavLink to="/securityLog" isActive={(match, location) =>
                    {
                        if (location.pathname.match(/\/securityLog/)) return true
                        return !!match
                    }}>
                        <span className="icon">
                            <BsShieldLock size={20}/>
                        </span>
                        <span className="label">Логи охраны</span>
                    </NavLink>
                </Menu.Item>

                {
                    profile?.idCompany === ID_SYSTEM_COMPANY
                        ? <Menu.Item key="14">
                            <NavLink to="/attributesVersion" isActive={(match, location) =>
                            {
                                if (location.pathname.match(/\/attributesVersionForm/)) return true
                                return !!match
                            }}>
                                <span className="icon">
                                    <GiGearHammer size={20}/>
                                </span>
                                <span className="label">Версии</span>
                            </NavLink>
                        </Menu.Item>
                        : null
                }

                <Menu.Item key="15">
                    <NavLink to="/Settings">
                        <span className="icon">
                            <RxGear size={20}/>
                        </span>
                        <span className="label">Настройки</span>
                    </NavLink>
                </Menu.Item>
            </Menu>
        </>
    )
})

